import { render, staticRenderFns } from "./Diversityplot.vue?vue&type=template&id=74447952"
import script from "./Diversityplot.vue?vue&type=script&lang=js"
export * from "./Diversityplot.vue?vue&type=script&lang=js"
import style0 from "./Diversityplot.vue?vue&type=style&index=0&id=74447952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports